module.exports = "<ul id=\"u-menu\">\n  <li *ngFor=\"let p of pageList\" style=\"margin-top: 7px;\">\n    <a href=\"\" routerLink=\"{{p.KP_Redirect_URL}}\"\n      routerLinkActive=\"menu-active\">\n      <img src=\"/assets/images/icons/{{p.KP_Image_URL}}\">\n      <span style=\"display:block;font-size:13px;\">{{p.KHB_Page}}</span>\n    </a>\n  </li>\n</ul>\n<div class=\"clearfix\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/correspondence-tracking/ct-menu/ct-menu.component.html
// module id = ./src/app/correspondence-tracking/ct-menu/ct-menu.component.html
// module chunks = main